import tagsController from './tagsController'

export default tagsController



// WEBPACK FOOTER //
// ../src/controllers/tagsController/index.js